export enum ExportStatuses {
  notStarted = 'notStarted',
  inProgress = 'inProgress',
  completed = 'completed',
  failed = 'failed'
}

export type TabProps = {
  groupId: string
  projectId: string
}

export enum ProjectExportTypes {
  print = 'print',
  preview = 'preview'
}

export enum ProjectExportStatuses {
  exporting = 'exporting',
  merging = 'merging',
  error = 'error',
  warning = 'warning',
  completed = 'completed',
  waiting = 'waiting'
}
